export default "__VITE_ASSET__B89c6yo1__"